import React, { useEffect, useState } from 'react';
import './UserDrawer.css';

export default function UserDrawer({ user, open, onClose, onLogout }) {
  const [freshUser, setFreshUser] = useState(user);

  useEffect(() => {
    if (open && user && user.uid) {
      // Fetch latest user data from backend
      fetch(`https://devbite.vercel.app/api/user?uid=${user.uid}`)
        .then(res => res.json())
        .then(data => {
          if (data.user) {
            setFreshUser(data.user);
            localStorage.setItem('user', JSON.stringify(data.user));
          }
        })
        .catch(() => {
          setFreshUser(user); // fallback to original
        });
    }
    // eslint-disable-next-line
  }, [open, user]);

  if (!open) return null;
  const displayUser = freshUser || user;
  // Get initials if no photo
  const initials = displayUser.displayName
    ? displayUser.displayName
        .split(' ')
        .map((n) => n[0])
        .join('')
        .slice(0, 2)
        .toUpperCase()
    : 'U';

  function handleLogout() {
    localStorage.removeItem('user');
    localStorage.clear(); // Optionally clear all preferences
    window.location.reload();
  }

  return (
    <div className="user-drawer-bg" onClick={onClose}>
      <div className="user-drawer" onClick={e => e.stopPropagation()}>
        <button className="user-drawer-close" onClick={onClose}>&times;</button>
        <div className="user-drawer-avatar-row">
          {displayUser.photoURL ? (
            <img src={displayUser.photoURL} alt="User" className="user-drawer-avatar" />
          ) : (
            <div className="user-drawer-avatar user-drawer-initials">{initials}</div>
          )}
        </div>
        <div className="user-drawer-name">{displayUser.displayName || displayUser.email}</div>
        <div className="user-drawer-section">
          <button className="user-drawer-btn user-drawer-orders" onClick={() => window.location.href = '/myorders'}>
            <span className="user-drawer-icon">🛍️</span> <b>My Orders</b>
          </button>
        </div>
        <div className="user-drawer-section user-drawer-section-label">Wallet & Earnings</div>
        <div className="user-drawer-section">
          {displayUser.marketer === true && (
            <button className="user-drawer-btn" onClick={() => window.location.href = '/wallet'}>
              <span className="user-drawer-icon">💳</span> My Wallet
            </button>
          )}
          <button className="user-drawer-btn">
            <span className="user-drawer-icon">💰</span> Income <span className="user-drawer-chevron">⌄</span>
          </button>
        </div>
        <button className="user-drawer-logout" onClick={handleLogout}>
          <span className="user-drawer-logout-icon">↩️</span> Logout
        </button>
      </div>
    </div>
  );
}
